var map = {
	"./Services": 7536,
	"./Services.css": 9893,
	"./Services.jsx": 7536,
	"./imgs/slide1.png": 511,
	"./imgs/slide2.png": 6948,
	"./imgs/slide3.png": 3101,
	"./imgs/slide4.png": 1538,
	"./imgs/slide5.png": 539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7569;